<template>
  <container :security-tips="true">
        <div class="text">
            <h2>额度正在计算中</h2>
            <p>结果预计在10分钟内算出,请耐心等待</p>
        </div>
      <div class="animation">
        <div class="cube-wrapper">
          <ul class="cube-inner">
            <li class="front"></li>
            <li class="back"></li>
            <li class="right"></li>
            <li class="left"></li>
            <li class="top"></li>
            <li class="bottom"></li>
          </ul>
          <ul class="cube">
            <li class="front"></li>
            <li class="back"></li>
            <li class="right"></li>
            <li class="left"></li>
            <li class="top"></li>
            <li class="bottom"></li>
          </ul>
          <ul class="cube-outer">
            <li class="front"></li>
            <li class="back"></li>
            <li class="right"></li>
            <li class="left"></li>
            <li class="top"></li>
            <li class="bottom"></li>
          </ul>
        </div>
      </div>
      <div class="action">
        <mu-button color="primary" text="继续填写资料,提升额度" @click="goon"></mu-button>
      </div>
  </container>
</template>
<style lang="less" rel="stylesheet/less" scoped="">
  @import "../../utils/_vars";

  @border-width:1px;
  @inner-width:78px/1.3;
  @cube-width:148px/1.3;
  @outer-width:200px/1.3;
  @animation-time: 3s;
  @animation-delay:0s;

  .text {
    padding: 56px 0 45px 0;
    text-align: center;

    h2 {
      font-size: 20px;
      margin-bottom: 12px;
    }

    p {
      font-size: @normalTextFontSize;
    }
  }
  
  .action {
    margin: 40px 20px 0 20px;
  }

  .cube-wrapper {
    width: 100%;
    height: 330px;
    position: relative;
    overflow: hidden;
  }

  .cube-outer {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: unit(0-unit(@outer-width)/2,px) 0;
    transform-origin: @outer-width/2 @outer-width/2;
    transform: rotateX(-33.5deg) rotateY(45deg);
    transform-style: preserve-3d;
    animation: slowspin @animation-time ease-in-out @animation-delay infinite;
    margin: unit(0-unit(@outer-width)/2,px) 0 0 unit(0-unit(@outer-width)/2,px);
    top: 50%;
    left: 50%;
  }

  .cube-outer,
  .cube-outer li {
    position: absolute;
    display: block;
  }

  .cube-outer li {
    width: @outer-width;
    height: @outer-width;
    transition: transform 1s ease-in-out;
  }

  .cube-outer li:after {
    content: '';
    display: block;
    position: absolute;
    width: @outer-width;
    height: @outer-width;
    backface-visibility: hidden;
    transition: transform 1s ease-in-out;
    border: @border-width solid rgba(72,139,244,0.5);
  }

  .cube-outer .front {
    transform: translateZ(@outer-width/2);

    &:after {
      border-right-width: @border-width * 2;
      border-top-width: @border-width * 2;
    }
  }

  .cube-outer .back {
    transform: rotateX(-180deg) translateZ(@outer-width/2);
  }

  .cube-outer .right {
    transform: rotateY(90deg) translateZ(@outer-width/2);
  }

  .cube-outer .left {
    transform: rotateY(-90deg) translateZ(@outer-width/2);
  }

  .cube-outer .top {
    transform: rotateX(90deg) translateZ(@outer-width/2);

    &:after {
      border-left-width: @border-width * 2;
      border-bottom-width: @border-width * 2;
    }

  }

  .cube-outer .bottom {
    transform: rotateX(-90deg) translateZ(@outer-width/2);

    &:after {
      border-right-width: @border-width * 2;
      border-bottom-width: @border-width * 2;
    }
  }

  .cube {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: unit(0-unit(@cube-width)/2,px) 0;
    transform-origin: @cube-width/2 @cube-width/2;
    transform: rotateX(-33.5deg) rotateY(45deg);
    transform-style: preserve-3d;
    animation: slowspin @animation-time ease-in-out @animation-delay infinite;
    margin: unit(0-unit(@cube-width)/2,px) 0 0 unit(0-unit(@cube-width)/2,px);
    top: 50%;
    left: 50%;
  }

  .cube,
  .cube li {
    position: absolute;
    display: block;
  }

  .cube li {
    width: @cube-width;
    height: @cube-width;
    transition: transform 1s ease-in-out;
  }

  .cube li:after {
    content: '';
    display: block;
    position: absolute;
    width: @cube-width;
    height: @cube-width;
    backface-visibility: hidden;
    transition: transform 1s ease-in-out;
    border: @border-width solid rgba(72,139,244,0.2);
  }

  .cube .front {
    transform: translateZ(@cube-width/2);
  }

  .cube .back {
    transform: rotateX(-180deg) translateZ(@cube-width/2);
  }

  .cube .right {
    transform: rotateY(90deg) translateZ(@cube-width/2);
  }

  .cube .left {
    transform: rotateY(-90deg) translateZ(@cube-width/2);
  }

  .cube .top {
    transform: rotateX(90deg) translateZ(@cube-width/2);
  }

  .cube .bottom {
    transform: rotateX(-90deg) translateZ(@cube-width/2);
  }

  .cube-inner {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: unit(0-unit(@inner-width)/2,px) 0;
    top: 50%;
    left: 50%;
    transform-origin: @inner-width/2 @inner-width/2;
    margin: unit(0-unit(@inner-width)/2,px) 0 0 unit(0-unit(@inner-width)/2,px);
    transform: rotateX(-33.5deg) rotateY(45deg);
    transform-style: preserve-3d;
    animation: fastspin @animation-time ease-in-out @animation-delay infinite;
  }

  .cube-inner,
  .cube-inner li {
    position: absolute;
    display: block;
  }

  .cube-inner li {
    width: @inner-width;
    height: @inner-width;
    transition: transform 1s ease-in-out;
  }

  .cube-inner .top:after {
    background-color: #2d8bfc;
  }

  .cube-inner .front:after,
  .cube-inner .back:after {
    background-color: #57a2fd;
  }

  .cube-inner .left:after,
  .cube-inner .right:after {
    background-color: #abd1f4;
  }

  .cube-inner li:after {
    content: '';
    display: block;
    position: absolute;
    width: @inner-width;
    height: @inner-width;
    backface-visibility: hidden;
    transition: transform 1s ease-in-out;
  }

  .cube-inner .front {
    transform: translateZ(@inner-width/2);
  }

  .cube-inner .back {
    transform: rotateX(-180deg) translateZ(@inner-width/2);
  }

  .cube-inner .right {
    transform: rotateY(90deg) translateZ(@inner-width/2);
  }

  .cube-inner .left {
    transform: rotateY(-90deg) translateZ(@inner-width/2);
  }

  .cube-inner .top {
    transform: rotateX(90deg) translateZ(@inner-width/2);
  }

  .cube-inner .bottom {
    transform: rotateX(-90deg) translateZ(@inner-width/2);
  }

  @keyframes slowspin {
    0% {
      transform: rotateX(-33.5deg) rotateY(45deg);
    }

    100% {
      transform: rotateX(-33.5deg) rotateY(225deg);
    }
  }

  @keyframes fastspin {
    0% {
      transform: rotateX(-33.5deg) rotateY(45deg);
    }

    100% {
      transform: rotateX(-33.5deg) rotateY(-315deg);
    }
  }

</style>
<script  >
  export default {
    methods: {
      goon() {
        this.$router.replace('credits');
      }
    }
  };
</script>
